module.exports = __webpack_public_path__ + "static/media/first_disabled.e86f5f2e.svg";